import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class ValidatorService {
  constructor(private translateService: TranslateService) {}

  public getErrorMessage(control: AbstractControl | null, formGroupChecked: boolean): string {
    if (!formGroupChecked || control === null || !control.errors) {
      return '';
    }
    const firstErrorKey = Object.keys(control.errors)[0];
    return this.translateService.instant(`VALIDATIONS.${firstErrorKey.toUpperCase()}`);
  }

  public getLoadingErrorMessage(control: AbstractControl | null, formGroupChecked: boolean): string {
    if (!formGroupChecked || control === null || !control.errors) {
      return '';
    }
    return this.translateService.instant('VALIDATIONS.LOADING');
  }

  public getDateOfBirthErrorMessage(formGroup: AbstractControl | null, formGroupChecked: boolean): string {
    const control = formGroup?.get('dateOfBirth');
    if (!formGroupChecked || !formGroup || !control || (!control.errors && !formGroup.errors)) {
      return '';
    }
    if (control.hasError('required')) {
      return this.translateService.instant('VALIDATIONS.REQUIRED');
    }
    const dateOfBirthError = control.getError('dateOfBirth') ?? formGroup.getError('dateOfBirth');
    if (dateOfBirthError) {
      return this.translateService.instant(`VALIDATIONS.DATE_OF_BIRTH.${dateOfBirthError}`);
    }
    return this.translateService.instant('VALIDATIONS.DATE_OF_BIRTH.INVALID_DATE');
  }

  public getEmailErrorMessage(control: AbstractControl | null, formGroupChecked: boolean): string {
    if (!formGroupChecked || control === null || !control.errors) {
      return '';
    }
    const firstErrorKey = control.getError('email');
    return this.translateService.instant(`VALIDATIONS.EMAIL.${firstErrorKey.toUpperCase()}`);
  }
}
